import React, { useState, useEffect } from 'react';
import './HorseView.scss';
import SetFavorites from './SetFavorites';
import YoutubeLinkFrom from './YoutubeLinkForm';

// import saleCover from './images/ECTestCover.png';

// Hook
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
  
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      
      // Add event listener
      window.addEventListener("resize", handleResize);
      
      // Call handler right away so state gets updated with initial window size
      handleResize();
      
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
  
    return windowSize;
}

export default function SaleView() {
    const size = useWindowSize();
    const lockOpen = size.width > 1300;
    const saleCover = global.drupalSettings.catalogues.ec_background_cover;
    return (
        <>
            <SetFavorites />

            <div className='sale-view' style={{
                marginLeft: lockOpen ? 350 : 0,
                textAlign: 'center',
            }}>
                <div style={{textAlign: 'left'}}>
                    <YoutubeLinkFrom />
                </div>
                <img
                    className="img-fluid"
                    style={{
                        minWidth: '100%',
                    }}
                    src={saleCover.replace('http://','https://').replace('fasig-tipton','fasigtipton')}
                    alt="Fasig-Tipton Sale"
                />
            </div>
        </>
    )

}
